<template>
  <div class="has-text-left">
    <h5 :class="`mist-${language}-h5`" style="padding-top: 26px">
      {{ content.primary.info[0].text }}
    </h5>
    <div class="section" v-for="(item, i) in content.items" :key="i">
      <prismic-rich-text
        :class="`mist-${language}-h3 has-text-blue`"
        :field="item.sub_title"
      />
      <prismic-rich-text
        :field="item.info"
        :class="`mist-${language}-p`"
        style="padding-top: 20px"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["content"],
  computed: {
    language() {
      return this.$store.getters["language/language"];
    },
  },
};
</script>

<style scoped>
.section {
  padding: 20px 0 0;
}
.section:not(:last-child) {
  padding: 20px 0;
}
</style>